<template>
  <div class="max-w-7xl mx-auto px-6 lg:px-8 py-8">
    <BreadCrumbs v-bind:bcrumbs="bcrumbs" />

    <PageTitle v-bind:title="title" v-bind:admin="true" />

    <Loader v-if="loading" />
    <div v-else-if="data.id">
      <form class="space-y-4">
        <input type="hidden" name="id" v-model="data.id" />

        <div>
          <label for="name" class="block text-sm font-medium text-gray-700">
            Название вопроса
          </label>
          <div class="mt-1">
            <input
              v-model="data.name"
              type="text"
              name="name"
              id="name"
              autocomplete="name"
              class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
            />
            <p
              v-if="errors.validationEdit && errors.validationEdit.name"
              class="mt-2 text-sm text-red-600"
            >
              {{ errors.validationEdit.name[0] }}
            </p>
          </div>
        </div>
        <div>
          <label for="orderby" class="block text-sm font-medium text-gray-700">
            Сортировка
          </label>
          <div class="mt-1">
            <input
              v-model="data.orderby"
              type="text"
              name="orderby"
              id="orderby"
              autocomplete="orderby"
              class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
            />
            <p
              v-if="errors.validationEdit && errors.validationEdit.orderby"
              class="mt-2 text-sm text-red-600"
            >
              {{ errors.validationEdit.orderby[0] }}
            </p>
          </div>
        </div>

        <div>
          <label for="text" class="block text-sm font-medium text-gray-700">
            Текст вопроса</label
          >
          <!-- <textarea name="text" id="text" cols="30" rows="10" v-model="data.text"></textarea> -->

          <!-- content_style: 'body { background-color: black !important; }  tox-notifications-container { top: -30px; background-color: black !important;} ', -->
          <Editor
            api-key="API_KEY"
            v-model="data.text"
            :init="{
              height: 400,
              skin: 'oxide-dark',
              plugins: 'wordcount',
              //menubar: 'insert',
              image_advtab: true,
              //images_upload_url: '/upload1',
              automatic_uploads: true,
              file_picker_types: 'image',
              images_upload_handler: uploadImage,
            }"
            plugins="image link insertdatetime table emoticons media"
            toolbar="image link insertdatetime table emoticons media"
          />
        </div>
        <div>
          <div class="flex justify-end">
            <button
              @click.prevent="editRecord()"
              type="submit"
              class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Сохранить изменения
            </button>
          </div>
          <ErrorMessage v-if="errors.edit" :error="errors.edit" class="mt-2" />
        </div>
      </form>

      <!-- <form>
        <input type="hidden" name="id" v-model="data.id" />
        <div class="form-group">
          <label for="name" class="col-form-label">Название вопроса:</label>
          <input
            type="text"
            class="form-control"
            id="name"
            name="name"
            v-model="data.name"
          />
          <div
            class="alert alert-danger"
            v-if="errors.validationEdit && errors.validationEdit.name"
          >
            {{ errors.validationEdit.name[0] }}
          </div>
        </div>
        <div class="form-group">
          <label for="orderby" class="col-form-label">Сортировка:</label>
          <input
            type="text"
            class="form-control"
            id="orderby"
            name="orderby"
            v-model="data.orderby"
          />
          <div
            class="alert alert-danger"
            v-if="errors.validationEdit && errors.validationEdit.orderby"
          >
            {{ errors.validationEdit.orderby[0] }}
          </div>
        </div>
        <div class="form-group">
          <label for="text" class="col-form-label">Текст вопроса:</label>
          <Editor
            api-key="API_KEY"
            v-model="data.text"
            :init="{
              height: 600,
              skin: 'oxide-dark',
              plugins: 'wordcount',
              //menubar: 'insert',
              image_advtab: true,
              //images_upload_url: '/upload1',
              automatic_uploads: true,
              file_picker_types: 'image',
              images_upload_handler: uploadImage,
            }"
            plugins="image link insertdatetime table emoticons media"
            toolbar="image link insertdatetime table emoticons media"
          />
        </div>
      </form>
      <div class="alert alert-danger" v-if="errors.edit">
        {{ errors.edit }}
      </div>
      <button
        type="button"
        class="btn btn-primary"
        @click.prevent="editRecord()"
      >
        Сохранить изменения
      </button> -->
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
import BreadCrumbs from "@/components/BreadCrumbs";
import PageTitle from "@/components/PageTitle";
import Editor from "@tinymce/tinymce-vue";

export default {
  //watch: {
    //data: {
      //deep: true,
      /*
            handler: function(val, oldVal) {
                //console.log(val, oldVal);
                // это щас не исп-ся, тут можно отслеживать изменение в data
                console.log('WATCH-325!');
            }
            */
//    },
//  },

  data() {
    return {
      loading: true,
      data: [],
      errors: { load: "", edit: "", validationEdit: {} },
      bcrumbs: [],
      title: "Редактирование вопроса",
    };
  },

  async mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get(
          "admin/exams/" + this.$route.params.id + "/edit"
        );
        this.data = response.data.exam;
        this.bcrumbs = response.data.bcrumbs;
        this.loading = false;
      } catch (e) {
        this.errors.load = "Ошибка при загрузке данных";
      }
    },

    //
    // Edit record.
    //
    async editRecord() {
      this.errors.validationEdit = {};
      this.errors.edit = "";
      try {
        let response = await axios.post(
          "admin/exams/" + this.data.id,
          Object.assign(this.data, { _method: "PUT" })
        );
        if (response.status == 200) {
          this.loadData();
        }
      } catch (e) {
        if (e.response.status == 422) {
          this.errors.validationEdit = e.response.data.errors;
        } else if (e.response.status == 520) {
          this.errors.edit = e.response.data.error;
        } else {
          this.errors.edit = "Неизвестная ошибка при редактировании записи.";
        }
      }
    },

    uploadImage(blobInfo, success, failure) {
      this.errors.uploadfile = "";
      const config = { "content-type": "multipart/form-data" };
      const formData = new FormData();
      formData.append("file", blobInfo.blob(), blobInfo.filename());

      //formData.append('name', this.name)
      //formData.append('attachment', this.attachment)

      //axios.post('chapters/testUpload', formData, config)
      axios
        .post(
          "admin/courses/" + this.data.id + "/uploadimage",
          formData,
          config
        )
        //.then(response => console.log(response.data.message))
        //.catch(error => console.log(error))
        .then((response) => {
          //console.log(response.data);
          success(response.data.location);
        })
        .catch((error) => {
          failure("HTTP Error." + error.response.data.errors.file[0]);
          if (error.response.status == 520) {
            this.errors.uploadfile = error.response.data.error;
          } else {
            this.errors.uploadfile = "Неизвестная ошибка при загрузке файла.";
          }
        });
    },
  },

  components: {
    Loader,
    BreadCrumbs,
    PageTitle,
    Editor,
  },
};
</script>